import React, { useState, useEffect, useContext } from "react";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import moment from "moment";

import getAllVraShiftAPIS from "apis/panel/vraShifts/vraShifts.js";
import RadRosterApis from "apis/panel/rpRoster/rpRadRoster";
import Context from "context/context";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const EditRadRoster = ({ id, onClose }) => {
  const { dispatch } = useContext(Context);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [deployedDate, setDeployedDate] = useState(null);
  const [plannedDeploymentDate, setPlannedDeploymentDate] = useState(null);
  const [radiologistFormattedName, setRadiologistFormattedName] = useState("");
  const [radiologistUsername, setRadiologistUsername] = useState("");
  const [raddvfname, setRaddvfname] = useState('')
  const [radrosterId, setRadrosterId] = useState("");
  const [status, setStatus] = useState("");
  const [region, setRegion] = useState("");
  const [platform, setPlatform] = useState("");
    const [mosaicDrafting, setMosaicDrafting] = useState("");
  const [vraNeededCount, setVraNeededCount] = useState(0);
  const [timezone, setTimezone] = useState("");
  const [practice, setPractice] = useState("");
  const [email, setEmail] = useState("");
  const [schedulePattern, setSchedulePattern] = useState("");
  const [discontinueddate, setDiscontinuedDate] = useState(null);
  const [reasonforDiscontinuition, setReasonforDiscontinuition] = useState("");
  const [vraEmployees, setVraEmployees] = useState([]);
  const [radHandledBy, setRadHandledBy] = useState("");
  const [primaryVra, setPrimaryVra] = useState("");
  const [shiftStartTime, setShiftStartTime] = useState(dayjs());
  const [downsizingDate, setDownsizingDate] = useState(null);
  const [downsizingReason, setDownsizingReason] = useState("");

  const { getAllVraRosterAPI } = getAllVraShiftAPIS();

  const handleGetAllVraEmployees = async () => {
    try {
      let res = await getAllVraRosterAPI();
      setVraEmployees(res?.data?.vraMaster || []);
    } catch (err) {}
  };

  useEffect(() => {
    handleGetAllVraEmployees();
  }, []);

  const handleGetEditDataObj = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let values;
      values = {
        radRosterId: id,
      };
      const res = await getRadRosterFindOne(values);

      if (res?.data) {
        setRadrosterId(id);
        setFirstName(res?.data?.radRosterDetails?.firstname);
        setLastName(res?.data?.radRosterDetails?.lastname);
        setStatus(res?.data?.radRosterDetails?.status);
        setRegion(res?.data?.radRosterDetails?.region);
        setPlatform(res?.data?.radRosterDetails?.platform);
        setDeployedDate(res?.data?.radRosterDetails?.deployeddate);
        setRadiologistUsername(
          res?.data?.radRosterDetails?.radiologistusername
        );
        setRadiologistFormattedName(
          res?.data?.radRosterDetails?.radiologistformattedname
        );
        setRaddvfname(
          res?.data?.radRosterDetails?.raddvfname
        )
        setPlannedDeploymentDate(
          res?.data?.radRosterDetails?.planneddeploymentdate
        );
        setVraNeededCount(res?.data?.radRosterDetails?.vraneededcount);
        setTimezone(res?.data?.radRosterDetails?.timezone);
        setPractice(res?.data?.radRosterDetails?.practice);
        setEmail(res?.data?.radRosterDetails?.email);
        setSchedulePattern(res?.data?.radRosterDetails?.schedulepattern);
        setDiscontinuedDate(res?.data?.radRosterDetails?.discontinueddate);
        setReasonforDiscontinuition(
          res?.data?.radRosterDetails?.discontinuedreason
        );
        setRadHandledBy(res?.data?.radRosterDetails.handledbyvraid);
        setPrimaryVra(res?.data?.radRosterDetails.primaryvraid);
        setDownsizingDate(res?.data?.radRosterDetails.downsizingdate);
        setDownsizingReason(res?.data?.radRosterDetails.downsizingreason);
        if (res?.data?.radRosterDetails.shiftstarttime) {
          const date = dayjs(
            `2024-11-21T${res?.data?.radRosterDetails.shiftstarttime}`
          );
          setShiftStartTime(date);
        }
      }
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const maxDate = new Date();

  const [errorFields, setErrorFields] = useState({
    firstName: false,
    lastName: false,
    deployedDate: false,
    plannedDeploymentDate: false,
    radiologistFormattedName: false,
    radiologistUsername: false,
    raddvfname:false,
    radrosterId: false,
    status: false,
    region:false,
    platform:false,
     mosaicDrafting:false,
    vraNeededCount: false,
    timezone: false,
    practice: false,
    email: false,
    schedulePattern: false,
  });

  // api's

  const { getRadRosterFindOne, updateRadRosterAPI } = RadRosterApis();

  const handleSaveRadRosterEdit = async (e) => {
    e.preventDefault();

    const errors = {};

    if (!firstName) errors.firstName = true;
    if (!lastName) errors.lastName = true;
    if (!radiologistUsername) errors.radiologistUsername = true;
    if (!radiologistFormattedName) errors.radiologistFormattedName = true;
    if (!raddvfname) errors.raddvfname = true;
    if (!practice) errors.practice = true;
    if (!timezone) errors.timezone = true;
    if (!status) errors.status = true;
    if(!region) errors.region = true;
    if(!platform) errors.platform = true;
    if (!vraNeededCount) errors.vraNeededCount = true;
    if (!email) errors.email = true;
    if (!schedulePattern) errors.schedulePattern = true;
    if(!mosaicDrafting) errors.mosaicDrafting=true;

    setErrorFields(errors);

    if (Object.keys(errors).length === 0) {
      let values = {
        radRosterId: radrosterId,
        firstName: firstName,
        lastName: lastName,
        vraNeededCount: parseFloat(vraNeededCount),
        radiologistUsername: radiologistUsername,
        radiologistFormattedName: radiologistFormattedName,
         radDvfName:raddvfname,
        status: status,
        region:region,
        platform:platform,
          mosaicDrafting:mosaicDrafting,
        timezone: timezone,
        practice: practice,
        email: email,
        schedulePattern: schedulePattern,
        radHandledBy: radHandledBy,
        primaryVra: primaryVra,
        shiftStartTime: shiftStartTime.format("hh:mm A"),
      };
      if (moment(deployedDate).isValid()) {
        values = {
          ...values,
          deployedDate: moment(deployedDate).format("YYYY-MM-DD"),
        };
      }
      if (moment(plannedDeploymentDate).isValid()) {
        values = {
          ...values,
          plannedDeploymentDate: moment(plannedDeploymentDate).format(
            "YYYY-MM-DD"
          ),
        };
      }
      if (moment(discontinueddate).isValid()) {
        values = {
          ...values,
          discontinuedDate: moment(discontinueddate).format("YYYY-MM-DD"),
        };
      } else {
        values = { ...values, discontinuedDate: null };
      }
      if(reasonforDiscontinuition){
        values = {...values,
          discontinuedReason: reasonforDiscontinuition
        }
      } else {
        values = { ...values, discontinuedReason: null };
      }
      if (moment(downsizingDate).isValid()) {
        values = {
          ...values,
          downsizingDate: moment(downsizingDate).format("YYYY-MM-DD"),
        };
      } else {
        values = { ...values, downsizingDate: null };
      }
      if (downsizingReason) {
        values = { ...values, downsizingReason };
      } else {
        values = { ...values, downsizingReason: null };
      }
      dispatch({ type: "SET_LOADING", payload: true });

      const res = await updateRadRosterAPI(values);

      if (res.status === "Ok") {
        onClose();
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.success("Data Saved Successfully", {
          toast: "Data Saved Successfully",
        });
      } else {
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.error("Error: User already exists in the system");
      }
    }
  };

  useEffect(() => {
    handleGetEditDataObj();
  }, []);

  const handleTimezoneChange = (event) => {
    const input = event.target.value;
    setTimezone(input);
  };

  const handlePracticeChange = (event) => {
    const input = event.target.value;
    setPractice(input);
  };

  const handleFirstNameChange = (event) => {
    const input = event.target.value;
    setFirstName(input);
  };

  const handleReasonChange = (event) => {
    let value = event.target.value
    value = value.replace(/ {2,}$/, " ");
    setReasonforDiscontinuition(value);
  };

  const handleLastNameChange = (event) => {
    const input = event.target.value;
    setLastName(input);
  };

  const handleRadiologistUsernameChange = (event) => {
    const input = event.target.value;
    setRadiologistUsername(input);
  };

  const handleRadiologistFormattedNameChange = (event) => {
    const input = event.target.value;
    setRadiologistFormattedName(input);
  };

  const handleVraNeededCountChange = (event) => {
    const input = event.target.value;
    if (/^\d*$/.test(input)) {
      setVraNeededCount(input);
      setErrorFields({ ...errorFields, vraNeededCount: false });
    } else {
      setErrorFields({ ...errorFields, vraNeededCount: true });
    }
  };

  const handleDeployedDateChange = (date) => {
    setDeployedDate(date);
  };

  const handleDiscontinuedDateChange = (date) => {
    setDiscontinuedDate(date);
  };

  const handlePlannedDeploymentDateChange = (date) => {
    setPlannedDeploymentDate(date);
  };

   const handleMosaicDraftingChange = (event) => {
    setMosaicDrafting(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };
  const handleRegionChange = (event) => {
    setRegion(event.target.value);
  };
  const handlePlatformChange = (event) => {
    setPlatform(event.target.value);
  };

  const handleEmailChange = (event) => {
    const input = event.target.value;
    setEmail(input);
  };

  const handleSchedulePatternChange = (event) => {
    const input = event.target.value;
    setSchedulePattern(input);
  };

   const handleRadDvfNameChange = (event) => {
        const input = event.target.value;

        setRaddvfname(input);

        
        

    };

  const handleKeyDown = (event) => {
    if (event.target.value.length === 0 && event.key === " ") {
      event.preventDefault();
    }
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <Grid container spacing={2} sx={{ pl: 4, pr: 5 }}>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            First Name <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="firstName"
            value={firstName}
            onChange={handleFirstNameChange}
            placeholder="Enter First Name"
            variant="outlined"
            fullWidth
          />
          {errorFields.firstName && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Last Name<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            value={lastName}
            name="middleName"
            onChange={handleLastNameChange}
            id="lastName"
            placeholder="Enter Last Name"
            variant="outlined"
            fullWidth
          />
          {errorFields.lastName && (
            <span className="error-msg">This is required Field</span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            RAD Full Name (Qgenda Name)<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="radiologistUsername"
            value={radiologistUsername}
            name="radiologistUsername"
            onChange={handleRadiologistUsernameChange}
            placeholder="Enter RAD Qgenda Full Name"
            variant="outlined"
            fullWidth
          />
          {errorFields.radiologistUsername && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            RAD SRF Name <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="radiologistFormattedName"
            value={radiologistFormattedName}
            name="radiologistFormattedName"
            onChange={handleRadiologistFormattedNameChange}
            placeholder="Enter RAD SRF Name"
            variant="outlined"
            fullWidth
          />
          {errorFields.radiologistFormattedName && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            {" "}
            RAD DVF Name<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="raddvfname"
            value={raddvfname}
            name="raddvfname"
            onChange={handleRadDvfNameChange}
            placeholder="Enter RAD DVF Name"
            variant="outlined"
            fullWidth
          />
          {errorFields.raddvfname && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>


        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Email<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="email"
            value={email}
            name="email"
            onChange={handleEmailChange}
            placeholder="Enter Email"
            variant="outlined"
            fullWidth
          />
          {errorFields.email && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Practice <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="practice"
            value={practice}
            onChange={handlePracticeChange}
            placeholder="Enter practice"
            variant="outlined"
            fullWidth
          />
          {errorFields.practice && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

         <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
                            <Box className="label">Mosaic Drafting <span style={{ color: "red" }}>*</span></Box>
                            <FormControl fullWidth>
        
                                <Select
                                    labelId="mosaicDrafting"
                                    id="mosaicDrafting"
        
                                    defaultValue=""
                                    displayEmpty
        
        
                                    name="mosaicDrafting"
                                    value={mosaicDrafting}
                                    onChange={handleMosaicDraftingChange}
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    style={{ border: "2px solid #B2D4F8", color: "grey" }}
                                >
                                    <MenuItem value="">
                                        Select Status
                                    </MenuItem>
        
                                    <MenuItem value={'Yes'}>Yes</MenuItem>
                                    <MenuItem value={'No'}>No</MenuItem>
                                    <MenuItem value={'Not Applicable'}>Not Applicable</MenuItem>
        
        
                                </Select>
                            </FormControl>
                            {/* <TextField sx={{ border: '1px solid #B2D4F8' }}id="role" value={Role}  name="role"  onChange={handleRoleChange} placeholder="Role" variant="outlined" fullWidth /> */}
                            {errorFields.mosaicDrafting && <span className="error-msg">This is required Field</span>}
                        </Grid>
        

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Timezone <span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="timezone"
            value={timezone}
            onChange={handleTimezoneChange}
            placeholder="Enter timezone "
            variant="outlined"
            fullWidth
          />
          {errorFields.timezone && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Region <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="region"
              id="region"
              defaultValue=""
              displayEmpty
              name="region"
              value={region}
              onChange={handleRegionChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem value="">Select Region</MenuItem>
              <MenuItem value={"Maverick"}>Maverick</MenuItem>
              <MenuItem value={"Genesis"}>Genesis</MenuItem>
              <MenuItem value={"Special Operations"}>Special Operations</MenuItem>
               <MenuItem value={"Matrix"}>Matrix</MenuItem>
              <MenuItem value={"Trailblazer"}>Trailblazer</MenuItem>
              <MenuItem value={"Apex"}>Apex</MenuItem>
              <MenuItem value={"Not Applicable"}>Not Applicable</MenuItem>
            </Select>
          </FormControl>
          {errorFields.region && (
            <span className="error-msg">This is required Field</span>
          )}
        </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Platform <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="platform"
              id="platform"
              defaultValue=""
              displayEmpty
              name="platform"
              value={platform}
              onChange={handlePlatformChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem value="">Select Platform</MenuItem>
              <MenuItem value={"Mosaic"}>Mosaic</MenuItem>
              <MenuItem value={"PowerScribe"}>PowerScribe</MenuItem>
              <MenuItem value={"Mosaic & PowerScribe"}>Mosaic & PowerScribe</MenuItem>
               <MenuItem value={"Not Applicable"}>Not Applicable</MenuItem>
            </Select>
          </FormControl>
          {errorFields.platform && (
            <span className="error-msg">This is required Field</span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">Deployed Date</Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="deployedDate"
              name="deployedDate"
              value={deployedDate ? new Date(deployedDate) : null}
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleDeployedDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: { clearable: true },
              }}
              minDate={new Date("2024-01-01")}
              maxDate={maxDate}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Schedule Pattern<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="schedulePattern"
            value={schedulePattern}
            name="schedulePattern"
            onChange={handleSchedulePatternChange}
            placeholder="Enter Schedule Pattern"
            variant="outlined"
            fullWidth
          />
          {errorFields.schedulePattern && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            VRA Needed<span style={{ color: "red" }}>*</span>
          </Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="vraNeededCount"
            value={vraNeededCount}
            name="vraNeededCount"
            onChange={handleVraNeededCountChange}
            placeholder="0"
            variant="outlined"
            fullWidth
            type="text"
            inputProps={{ step: "1", min: "0" }}
          />
          {errorFields.vraNeededCount && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>Only non-negative integers are allowed</div>
            </span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">
            Status <span style={{ color: "red" }}>*</span>
          </Box>
          <FormControl fullWidth>
            <Select
              labelId="status"
              id="status"
              defaultValue=""
              displayEmpty
              name="status"
              value={status}
              onChange={handleStatusChange}
              inputProps={{ "aria-label": "Without label" }}
              style={{ border: "2px solid #B2D4F8", color: "grey" }}
            >
              <MenuItem value="">Select Status</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              <MenuItem value={"Discontinued"}>Discontinued</MenuItem>
              <MenuItem value={"Planned"}>Planned</MenuItem>
               <MenuItem value={"Paused"}>Paused</MenuItem>
               <MenuItem value={"Not Applicable"}>Not Applicable</MenuItem>
            </Select>
          </FormControl>
          {errorFields.status && (
            <span className="error-msg">This is required Field</span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">Discontinued Date</Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="deployedDate"
              name="deployedDate"
              value={discontinueddate ? new Date(discontinueddate) : null}
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handleDiscontinuedDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: {
                  clearable: true,
                  onClear: () => setDiscontinuedDate(null),
                },
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
              minDate={new Date("2024-01-01")}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">Reason For Discontinuition</Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="firstName"
            onKeyDown={handleKeyDown}
            value={reasonforDiscontinuition}
            onChange={handleReasonChange}
            placeholder="Enter Reason For Discontinuition"
            variant="outlined"
            fullWidth
          />
          {errorFields.reasonforDiscontinuition && (
            <span
              className="error-msg"
              style={{ alignItems: "center", display: "flex", gap: "4px" }}
            >
              <div>
                <ErrorOutlineOutlinedIcon
                  style={{ alignItems: "center", alignSelf: "center" }}
                />{" "}
              </div>{" "}
              <div>This is required Field</div>
            </span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">Planned Deployment Date </Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="plannedDeploymentDate"
              name="plannedDeploymentDate"
              value={
                plannedDeploymentDate ? new Date(plannedDeploymentDate) : null
              }
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              onAccept={handlePlannedDeploymentDateChange}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: { clearable: true },
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
              minDate={new Date("2024-01-01")}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">RAD Handled By (RP ID)</Box>
          <Autocomplete
            id="rad-handled-by"
            options={vraEmployees}
            getOptionLabel={(option) => option.vraFullname || ""}
            renderInput={(params) => <TextField {...params} fullWidth />}
            isOptionEqualToValue={(option, value) =>
              option.vraRosterId === value.vraRosterId
            }
            value={
              vraEmployees?.filter((v) => v.vraRosterId === radHandledBy)[0] ||
              {}
            }
            onChange={(event, newValue) => {
              setRadHandledBy(newValue ? newValue.vraRosterId : "");
            }}
          />
          {errorFields.radHandledBy && (
            <span className="error-msg">
              RAD Handled By (RP ID) is required.
            </span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">Primary VRA (RP ID)</Box>
          <Autocomplete
            id="rad-handled-by"
            options={vraEmployees}
            getOptionLabel={(option) => option.vraFullname || ""}
            renderInput={(params) => <TextField {...params} fullWidth />}
            isOptionEqualToValue={(option, value) =>
              option.vraRosterId === value.vraRosterId
            }
            value={
              vraEmployees?.filter((v) => v.vraRosterId === primaryVra)[0] || {}
            }
            onChange={(event, newValue) => {
              setPrimaryVra(newValue ? newValue.vraRosterId : "");
            }}
          />
          {errorFields.radHandledBy && (
            <span className="error-msg">Primary VRA (RP ID) is required.</span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">Shift Start Time</Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer
              components={["TimePicker"]}
              style={{ overflowY: "scroll" }}
            >
              <TimePicker
                label=""
                value={shiftStartTime}
                sx={{ width: "100%" }}
                onChange={(newValue) => {
                  setShiftStartTime(newValue);
                }}
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorFields.radHandledBy && (
            <span className="error-msg">Shift Start Time is required.</span>
          )}
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">Downsizing Date</Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="downsizingDate"
              name="downsizingDate"
              sx={{ width: "100%", border: "2px solid #B2D4F8" }}
              fullWidth
              inputFormat="dd/MM/yyyy"
              slotProps={{
                field: {
                  clearable: true,
                  onClear: () => setDownsizingDate(null),
                },
              }}
              renderInput={(params) => <TextField {...params} fullWidth />}
              minDate={new Date("2024-01-01")}
              value={downsizingDate ? new Date(downsizingDate) : null}
              onChange={(date) => {
                setDownsizingDate(date);
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mt: 2 }}>
          <Box className="label">Downsizing Reason</Box>
          <TextField
            sx={{ border: "1px solid #B2D4F8" }}
            id="downsizingReason"
            onKeyDown={handleKeyDown}
            value={downsizingReason}
            onChange={(e) => {
              let value = e.target.value
              value = value.replace(/ {2,}$/, " ");
              setDownsizingReason(value);
            }}
            placeholder="Enter Reason For Downsizing"
            variant="outlined"
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }}>
        <Grid item xs={12} sm={2} md={2} lg={2}>
          <Button className="cancelButton" onClick={onClose}>
            Cancel
          </Button>
        </Grid>

        <Grid item sx={{ mr: 1 }} xs={12} sm={2} md={2} lg={2}>
          <Button className="saveButton" onClick={handleSaveRadRosterEdit}>
            Save
          </Button>
        </Grid>

      </Grid>
    </div>
  );
};

export default EditRadRoster;
